<template>
  <div>
    <!-------------------------Users Result------------------------------------------------------>
    <v-card flat>
      <!-------------------------part-1------------------------------->
      <v-row class="mt-5">
        <v-col>
          <v-text-field
            dense
            label="First user"
            single-line
            outlined
            hide-details=""
          ></v-text-field>
          <div class="my-1">
            <span style="color: rgba(34, 34, 34, 0.7)">
              (Search Last Name, First Name or Member ID)
            </span>
          </div>
        </v-col>
        <v-col>
          <v-text-field
            dense
            label="Second user"
            single-line
            outlined
            hide-details=""
          ></v-text-field>
          <div class="my-1">
            <span style="color: rgba(34, 34, 34, 0.7)">
              (Search Last Name, First Name or Member ID)
            </span>
          </div></v-col
        >
      </v-row>
      <div class="d-flex justify-center mt-5">
        <v-btn color="primary" class="mb-3 px-11">Submit</v-btn>
      </div>
      <div class="font-18 mb-2 mt-6"><b> Record 1 </b></div>
      <div style="overflow-x: auto" class="">
        <table>
          <tr>
            <th class="table_heading">Merge Type</th>
            <th class="table_heading">Name</th>
            <th class="table_heading">Membership</th>
            <th class="table_heading">Email</th>
            <th class="table_heading">Member ID</th>
            <th class="table_heading" style="width: 18%">Mailing Address</th>
            <th class="table_heading">Registration Date</th>
            <th class="table_heading">Renew By Date</th>
            <th class="table_heading">Status</th>
          </tr>
          <tr
            style="border: 1px solid #ddd"
            v-for="(item, i) in UserRecord"
            :key="i"
          >
            <td>
              <div class="d-flex">
                <v-radio class="pa-0 ma-0" value="radio-1"></v-radio>
                {{ item.merageType }}
              </div>
            </td>
            <td>{{ item.Name }}</td>
            <td>{{ item.membership }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.MemberID }}</td>
            <td>{{ item.MailingAddress }}</td>
            <td>{{ item.RegistrationDate }}</td>
            <td>{{ item.RenewByDate }}</td>
            <td>{{ item.status }}</td>
          </tr>
        </table>
        <div class="font-18 mb-2 mt-6"><b> Course History </b></div>
        <table>
          <tr>
            <th class="table_heading">Date</th>
            <th class="table_heading">Course</th>
            <th class="table_heading">Graduate Date</th>
            <th class="table_heading">Instructor</th>
          </tr>
          <tr
            style="border: 1px solid #ddd"
            v-for="(item, i) in UserRecord[0].courserHistory"
            :key="i"
          >
            <td>{{ item.courseDate }}</td>
            <td>{{ item.courseName }}</td>
            <td>{{ item.graduate }}</td>
            <td>{{ item.instructor }}</td>
          </tr>
        </table>
      </div>
      <div class="d-flex justify-center my-8">
        <v-btn color="primary">Merge </v-btn>
        <v-btn color="primary" class="ml-4">Merge and Delete </v-btn>
      </div>

      <!-------------------------part-2------------------------------->
      <div class="font-18 mb-2 mt-6"><b> Record 2</b></div>
      <div style="overflow-x: auto" class="pl-4">
        <table>
          <tr>
            <th class="table_heading">Merge Type</th>
            <th class="table_heading">Name</th>
            <th class="table_heading">Membership</th>
            <th class="table_heading">Email</th>
            <th class="table_heading">Member ID</th>
            <th class="table_heading" style="width: 18%">Mailing Address</th>
            <th class="table_heading">Registration Date</th>
            <th class="table_heading">Renew By Date</th>
            <th class="table_heading">Status</th>
          </tr>
          <tr
            style="border: 1px solid #ddd"
            v-for="(item, i) in UserRecord"
            :key="i"
          >
            <td>
              <div class="d-flex">
                <v-radio class="pa-0 ma-0" value="radio-1"></v-radio>
                {{ item.merageType }}
              </div>
            </td>
            <td>{{ item.Name }}</td>
            <td>{{ item.membership }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.MemberID }}</td>
            <td>{{ item.MailingAddress }}</td>
            <td>{{ item.RegistrationDate }}</td>
            <td>{{ item.RenewByDate }}</td>
            <td>{{ item.status }}</td>
          </tr>
        </table>
        <div class="font-18 mb-2 mt-6"><b> Course History </b></div>
        <table>
          <tr>
            <th class="table_heading">Date</th>
            <th class="table_heading">Course</th>
            <th class="table_heading">Graduate Date</th>
            <th class="table_heading">Instructor</th>
          </tr>
          <tr
            style="border: 1px solid #ddd"
            v-for="(item, i) in UserRecord[0].courserHistory"
            :key="i"
          >
            <td>{{ item.courseDate }}</td>
            <td>{{ item.courseName }}</td>
            <td>{{ item.graduate }}</td>
            <td>{{ item.instructor }}</td>
          </tr>
        </table>
      </div>
      <div class="d-flex justify-center my-8">
        <v-btn color="primary">Merge </v-btn>
        <v-btn color="primary" class="ml-4">Merge and Delete </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MerageMemberComponent",
  data() {
    return {
      ResultBox: false,
      SelectFirstUser: [
        "Gibert,Sherri 123",
        "Gibert,sherri 124",
        "Gibert,sherri 125",
      ],
      SelectSecondUser: [
        "Gibert,Sherri 123",
        "Gibert,sherri 124",
        "Gibert,sherri 125",
      ],
      UserRecord: [
        {
          merageType: "Master",
          membership: "Student",
          Name: "Amanda Bourgeois",
          MailingAddress: "710- A Porterfield RD Kamloops, BC V2B 6M7 Canad",
          email: "mana@gmail.com",
          MemberID: "30903",
          RegistrationDate: "12/15/2008",
          RenewByDate: "12/15/2008",
          status: "Active",
          courserHistory: [
            {
              courseDate: "250-320-1394",
              courseName: "BodyTalk Access",
              graduate: "12/15/2008",
              instructor: "Kenny Kristy",
            },
            {
              courseDate: "250-320-1394",
              courseName: "BodyTalk Access",
              graduate: "12/15/2008",
              instructor: "Kenny Kristy",
            },
            {
              courseDate: "250-320-1394",
              courseName: "BodyTalk Access",
              graduate: "12/15/2008",
              instructor: "Kenny Kristy",
            },
          ],
        },
        {
          merageType: "Merge",
        },
        // {
        //   merageType: "Master",
        //   membership: "Student",
        //   Name: "Amanda Bourgeois",
        //   MailingAddress: "710- A Porterfield RD Kamloops, BC V2B 6M7 Canad",
        //   PhoneNumer: "250-320-1394",
        //   MemberID: "30903",
        //   RegistrationDate: "12/15/2008",
        //   RenewByDate: "12/15/2008",
        //   status: "Active",
        //   courserHistory: [
        //     {
        //       courseDate: "250-320-1394",
        //       courseName: "BodyTalk Access",
        //       graduate: "12/15/2008",
        //       instructor: "Kenny Kristy",
        //     },
        //     {
        //       courseDate: "250-320-1394",
        //       courseName: "BodyTalk Access",
        //       graduate: "12/15/2008",
        //       instructor: "Kenny Kristy",
        //     },
        //     {
        //       courseDate: "250-320-1394",
        //       courseName: "BodyTalk Access",
        //       graduate: "12/15/2008",
        //       instructor: "Kenny Kristy",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    ShowResult() {
      this.ResultBox = true;
    },
  },
};
</script>

<style scoped>
.font-18 {
  font-size: 18px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

th,
td {
  text-align: left;
  padding: 11px;
}
.table_heading {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 500;
  color: rgba(8, 8, 22, 0.38);
}
</style>
